// src/pages/customer/components/details/hooks/useCustomerClubs.js
import { useCallback, useState } from "react";

import ClubSubscriptionAPI from '../../../../atendimento/club/api/ClubSubscriptionAPI';

const api = new ClubSubscriptionAPI();

export default function useCustomerClubs(customerId) {
  const [isLoading, setLoading] = useState(false);
  const [clubs, setClubs] = useState([]);

  const getClubs = useCallback(async () => {
    if (!customerId) return;

    try {
      setLoading(true);
      const resp = await api.getCustomerSubscriptions(customerId);
      setClubs(Array.isArray(resp.data) ? resp.data : []);
    } catch {
      setClubs([]);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  return { isLoading, clubs, getClubs };
}
